import { useAppSelector } from "../app/hooks";
import { selectCredentials } from "../features/credentials/credentialsSlice";
import { selectMessages } from "../features/messages/messagesSlice";
import { selectToken } from "../features/token/tokenSlice";
import { PayloadMessage, PayloadMessageType } from "../model/payload-message";

export type State = { messages: PayloadMessage[] };
export type Action = { type: "push"; message: PayloadMessage };
// function reducerMessage(state: State, action: Action): State {
//   switch (action.type) {
//     case "push":
//       return { messages: [...state.messages, action.message] };
//     default:
//       throw Error();
//   }
// }

export const useMessages = (emitSocketMessage: any) => {
  const credentials = useAppSelector(selectCredentials);
  const tokenChat = useAppSelector(selectToken);
  const messages = useAppSelector(selectMessages);

  const sendMessage = (message: string) => {
    if (!credentials) {
      return;
    } else {
      const { userKey: senderId, username: senderName } = credentials;
      const payload: any = {
        ...credentials,
        messageType: PayloadMessageType.TEXT,
        text: message,
        senderId: senderId,
        senderName: senderName,
        receiverId: tokenChat,
        receiverName: "escallo-chat",
      };
      emitSocketMessage(payload as any);
    }
  };

  function sendFile(url: string, mimeType: string, externalUrl: string, type: PayloadMessageType) {
    if (!credentials) {
      return;
    }
    const payload: any = {
      ...credentials,
      messageType: type,
      senderId: credentials.userKey,
      senderName: credentials.username,
      receiverId: tokenChat,
      receiverName: "escallo-chat",
    };
    switch (type) {
      case PayloadMessageType.AUDIO:
        payload.audio = { url, externalUrl, mimeType };
        break;
      case PayloadMessageType.IMAGE:
        payload.image = { url, externalUrl, mimeType };
        break;
      case PayloadMessageType.VIDEO:
        payload.video = { url, externalUrl, mimeType };
        break;
      case PayloadMessageType.DOCUMENT:
        payload.document = { url, externalUrl, mimeType };
        break;
      default:
        break;
    }

    emitSocketMessage(payload as any);
  }

  function sendImage(path: string, mimetype: string, externalDownload: string) {
    sendFile(path, mimetype, externalDownload, PayloadMessageType.IMAGE);
  }

  function sendVideo(path: string, mimetype: string, externalDownload: string) {
    sendFile(path, mimetype, externalDownload, PayloadMessageType.VIDEO);
  }

  function sendAudio(path: string, mimetype: string, externalDownload: string) {
    sendFile(path, mimetype, externalDownload, PayloadMessageType.AUDIO);
  }

  function sendDocument(path: string, mimetype: string, externalDownload: string) {
    sendFile(path, mimetype, externalDownload, PayloadMessageType.DOCUMENT);
  }

  return {
    sendMessage,
    sendFile,
    sendImage,
    sendVideo,
    sendAudio,
    sendDocument,
    messages,
  };
};
